import { action } from 'easy-peasy';
import { IActionSetAllActTeams } from '../types';

const setAllActTeams: IActionSetAllActTeams = action((state, payload) => {
  state.allActTeams = payload;
});

export default setAllActTeams;
